<ul class="form-errors" *ngIf="for && for.errors && for.touched === touched">
    <li *ngFor="let error of for.errors | keys" [hidden]="!error || error === 'required'">
        {{ 'shared.form.error.' + (keys[error] ? keys[error] : error) | translate : for.errors[error] || {} }}
    </li>
</ul>

<ul class="form-errors" *ngIf="errors">
    <li *ngFor="let error of errors | keys" [hidden]="!error">
        {{ 'shared.form.error.' + (keys[error] ? keys[error] : error) | translate : errors[error] || {} }}
    </li>
</ul>
